
import axios from 'axios';


export default {
  /**
   * 列出检测报告
   * @param {*} params 
   */
  getRecords(params) {
    return axios.get(`/api/reports/`, {params:params})
  },

  /**
   * 获取检测报告详情s
   * @param {*} reportUUID 
   * @param {*} params 
   */
  getRecordDetail(reportUUID, params) {
    return axios.get(`/api/reports/${reportUUID}/`, {params:params})
  },

  getDownload(){
    return axios.get('/api/app/latest_version/');
  },
  

    /**
   * 获取检测报告详情大车
   * @param {*} reportUUID 
   * @param {*} params 
   */
  getRecordDetailcar(reportUUID, params) {
    return axios.get(`/api/lorry_reports/${reportUUID}/`, {params:params})
  },

  
}


// WEBPACK FOOTER //
// ./src/api/api.js